import React,{useEffect,useState} from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as p, Legend, ResponsiveContainer } from 'recharts';

import { useGetUserProfileDetail,useDeleteTenant ,useGetUserLogins} from '../../Hooks';
import { useSelector } from 'react-redux';
import { Box,Grid,Typography,Tooltip,Button } from '@mui/material';
import {CircularProgress} from '@mui/material';
import ImageSelector from '../../../../components/GlobalComponents/ImageSelector/ImageSelector';
import PersonOutlineOutlined from '@mui/icons-material/PersonOutlineOutlined';
import {ReactComponent as ProfilVector} from '../../StaticData/Vectors/ProfileVector.svg';
import { useGetPersonPicture } from '../../Hooks';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
import ChangeEmail from "../../Forms/ChangePassword/ChenageEmail";
import {IconButton} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { redirect, redirectDocument } from 'react-router-dom';
import { useAuth } from "../../../../Context/AuthProvider";
import { useDispatch } from "react-redux";
import { resetRValuesR } from "../../../../scenes/Meeting/MeetingsSlice/MeetingsSlice";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import EditIcon from '@mui/icons-material/Edit';

const Profile = () => {
    const[showToastMessge,setShowToastMessage]=useState(null)
    const[profileDetials,setProfileDetails]=useState<any>(null)
    const personId=useSelector((state:any)=>state.loign.personId);
    const{data:personPictureData}=useGetPersonPicture(personId);
    const[imgSrc,setImgSrc]=useState<any>(null);
    const[changeImgData,setChangeImgData]=useState<any>(null)
    const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
    const newAuth = useAuth();
    const dispatch = useDispatch();
    const{mutate:deleteTenant,isError,isSuccess,data:deleteData}=useDeleteTenant()
    let body:any={
        tenantId:tenantId,
        personId:personId
    };
    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };
    const initialDeleteTenant=()=>{
      let deleteBody={
        tenantId:tenantId
      }
      deleteTenant(deleteBody)
      handleClose();

   }
   const theme = useTheme();
   const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // برای بررسی سایز صفحه
    const{data:personDetData,isLoading}=useGetUserProfileDetail(body);
    const{data:personLoginData}=useGetUserLogins(body);

    const initiaLogOut = () => {
      newAuth.logout();
      localStorage.setItem("accessToken", "");
      dispatch(resetRValuesR());
    };
     
  useEffect(() => {
    
   if (personPictureData) {
     let{pictureBase64String}=personPictureData;
     setImgSrc(pictureBase64String)
   }
     }, [personPictureData])


    useEffect(() => {
      if (deleteData) {
        let{data}=deleteData;
        let{isSuccess}=data;
        if (isSuccess) {
         initiaLogOut();
        }
      }
    }, [deleteData])

   
    useEffect(() => {
      
    if (personDetData) {
        let{name,
            phoneNumber,
            roleName,
            teamName,
            companyName,
            managerName,
            registerDate,
            email

        }=personDetData;
        let details={
            name:name,
            phoneNumber:phoneNumber,
            roleName:roleName,
            teamName:teamName,
            companyName:companyName,
            managerName:managerName,
            registerDate:registerDate,
            email:email
        }
        // setProfileDetails(detias)
        setProfileDetails(details)
    }
     
    }, [personDetData])
    const [showChangeEmail, setShowChangeEmail] = useState<boolean>(false);

    const initialChangeEmail= (): void => {
      setShowChangeEmail((prev) => !prev);
    };
    
    const data = [
      {
        name: 'Page A',
        uv: 4000,
        pv: 2400,
        amt: 2400,
      },
      {
        name: 'Page B',
        uv: 3000,
        pv: 1398,
        amt: 2210,
      },
      {
        name: 'Page C',
        uv: 2000,
        pv: 9800,
        amt: 2290,
      },
      {
        name: 'Page D',
        uv: 2780,
        pv: 3908,
        amt: 2000,
      },
      {
        name: 'Page E',
        uv: 1890,
        pv: 4800,
        amt: 2181,
      },
      {
        name: 'Page F',
        uv: 2390,
        pv: 3800,
        amt: 2500,
      },
      {
        name: 'Page G',
        uv: 3490,
        pv: 4300,
        amt: 2100,
      },
    ];

    const getIntroOfPage = (label:any) => {
      if (label === 'Page A') {
        return "Page A is about men's clothing";
      }
      if (label === 'Page B') {
        return "Page B is about women's dress";
      }
      if (label === 'Page C') {
        return "Page C is about women's bag";
      }
      if (label === 'Page D') {
        return 'Page D is about household goods';
      }
      if (label === 'Page E') {
        return 'Page E is about food';
      }
      if (label === 'Page F') {
        return 'Page F is about baby food';
      }
      return '';
    };

    const CustomTooltip = ({ active, payload, label } : any) => {
      if (active && payload && payload.length) {
        return (
          <div className="custom-tooltip">
            <p className="label">{`${label} : ${payload[0].value}`}</p>
            <p className="intro">{getIntroOfPage(label)}</p>
            <p className="desc">Anything you want can be displayed here.</p>
          </div>
        );
      }
    
      return null;
    };

    const [open, setOpen] = React.useState(false);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  
    if (isLoading) {
        return  <Box py={5} textAlign={'center'} >
        <CircularProgress/>
        </Box>
    }

  return (
    <Grid container  >
    <Grid item xs={12}  >
   <Box px={4} py={1}>

   </Box>

   <Box sx={{bgcolor:'#E5F1FF',borderRadius:5,p:3,mx:'auto'}} width={'98%'}  >
    <Box display={'flex'} justifyContent={'start'}  >
    <Box sx={{p:1}} width={'10%'}  >
    <img src={imgSrc} width={'70px'} 
    style={{borderRadius:'50%',boxShadow:'20px'}}
     />
    </Box>
    <Box width={'60%'} rowGap={2}   >
         <Box mt={1}  >
            <Typography variant='h5' fontWeight={600}  >{profileDetials?.name}</Typography>
         </Box>
         <Box mt={1}>
            <Typography  variant='h6' fontWeight={400}>{profileDetials?.phoneNumber}</Typography>
         </Box>
         <Box display={'flex'}  justifyContent={'start'} flexDirection={'row'} >

         <Box mt={1}>
            <Typography  variant='h6' fontWeight={400}>{profileDetials?.email}</Typography>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialChangeEmail()
            }
            className={`btn px-5  text-xs font-thin text-[#00387c]
               btn-sm rounded-md`}
          >
            <EditIcon/>
          </button> 
                 </Box>
{/* 
          <Box >
        <IconButton onClick={()=>{
            initialChangeEmail()
        }}   >
        <EditIcon color='primary'   />
       </IconButton>
         </Box> */}
         </Box>

    </Box>
    <Box >
        <ImageSelector setChangeImgData={setChangeImgData} setShowToastMessage={setShowToastMessage} />
    </Box>
    
    </Box>
   </Box>
    </Grid>

    <Grid item xs={12}  >
    <Box display={'flex'} 
    p={3}
    flexDirection={'column'}
     alignItems={'start'} 
    justifyContent={'start'} 
    rowGap={1}
    >
     <Box>
        <Typography variant='body1'  fontWeight={900} >
        اطلاعات سازمانی
        </Typography>
     </Box>

     <Box display={'flex'}  >
     <Typography variant='body2' fontWeight={700}  >نقش:</Typography>
        <Typography  px={0.5} variant='body2'>
         { profileDetials?.cultureRoleName}
        </Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>تیم:</Typography>
        <Typography   px={0.5} variant='body2' >{profileDetials?.teamName}</Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>نام شرکت:</Typography>
        <Typography px={0.5} variant='body2'>{profileDetials?.companyName}</Typography>
     </Box>
     <Box display={'flex'}>
        <Typography variant='body2' fontWeight={700}>نام مدیر:</Typography>
        <Typography px={0.5} variant='body2'>{profileDetials?.managerName}</Typography>
     </Box>

    <Box sx={{mt:3}}>
        <Typography variant='body1'  fontWeight={900}>
        اطلاعات کاربری
        </Typography>
     </Box>
     <Box display={'flex'}>
        <Typography>تاریخ عضویت:</Typography><Typography>{profileDetials?.registerDate}</Typography>
          {/* <ResponsiveContainer width="300%" height="100%">
        <BarChart
          width={500}
          height={300}
          // data={personLoginData === null || personLoginData === undefined ? data : personLoginData}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="Date" />
          <YAxis />
          <Legend />
          <Bar dataKey="Count" barSize={20} fill="#8884d8" />
        </BarChart>
      </ResponsiveContainer> */}
     </Box>
     
   
     {/* <Box display={'flex'}>
    <Tooltip  title="حذف">
        <IconButton onClick={()=>{initialDeleteTenant()}}  >
        <Typography fontWeight={600} color={'red'}>حذف حساب کاربری</Typography><DeleteIcon color='error'/>
        </IconButton>
        </Tooltip>
     </Box> */}
          
           <Box display={'flex'}>
            <Tooltip  title="حذف حساب کاربری">
        <IconButton  onClick={handleClickOpen}>
        <Typography fontWeight={600} color={'red'}>حذف حساب کاربری</Typography><DeleteIcon color='error'/>
        </IconButton>
        </Tooltip>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" fontWeight={600} fontSize={'17px'}>
        {"آیا از حذف حساب کاربری اطمینان دارید؟"}
        </DialogTitle>
        {/* <DialogContent>
        </DialogContent> */}
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
          <Typography  color={'red'}> انصراف</Typography> 
          </Button>
          <Button  onClick={()=>{initialDeleteTenant()}}  autoFocus>
          <Typography  color={'#00387C'} > تایید</Typography> 
          </Button>
        </DialogActions>
      </Dialog>
      </Box>

      <div style={{ width: '100%', height: 300 }}>
     <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={personLoginData === null || personLoginData === undefined ?  data : personLoginData}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          {/* <p 
             content={<CustomTooltip />}
            /> */}
          <Legend />
          <Bar dataKey="count" barSize={20} fill="#00387C" name='تعداد' />
        </BarChart>
      </ResponsiveContainer>
      </div>

    </Box>
    
    <div>         
          <ModalLyt
            showModal={showChangeEmail}
            setShowModal={setShowChangeEmail}
            height={500}
            width={isMobile ? '330px' : '600px'}  // در موبایل 350px و در سایر اندازه‌ها 600px
            title={"ایمیل"}
           
          >
            <ChangeEmail
              onSuccess={showChangeEmail}
              email={profileDetials?.email}
              setShowToastMessage = {setShowToastMessage}
              onClose={setShowChangeEmail}
            />
          </ModalLyt>
        </div>
    </Grid>   
   {
      showToastMessge && <DYToastMessage
      isSuccess={true}
      message={'باموفقیت انجام شد'}
      setShow={setShowToastMessage}
      show={showToastMessge}
      />
    }
    </Grid>
  )
}

export default Profile